import { P0, S, abs, core, moodK, scaleAt, sq } from '../../geometry';

export const bars = {
  name: 'Bars',
  colors: ['#2F9E5B', '#E3A008'],
  draw(m, t) {
    const h = (i) => {
      if (m === 'happy') return 12 + 8 * abs(S(t * 7 + i * 0.8));
      // Thinking: a wave keeps rolling across the bars.
      if (m === 'thinking') return 6 + 10 * (0.5 + 0.5 * S(t * 4 - i * 0.9));
      if (m === 'talking') return 5 + 10 * abs(S(t * 8 + i * 2.1));
      if (m === 'surprised') return 22 - abs(i - 2) * 4;
      if (m === 'paused') return 0.01 + 0.6 * (0.5 + 0.5 * S(t * 0.8 + i));
      return 6 + 2 * S(t * 1.5 + i);
    };
    const pose = P0();
    if (m === 'happy') pose.ty = -2 * abs(S(t * 6));
    return {
      strokes: [32, 41, 50, 59, 68].map((x, i) => ({
        c: i === 2 ? 'b' : 'a',
        pts: [
          [x, 84],
          [x, 84 - h(i)],
        ],
      })),
      eyes: { x: 50, y: 50 },
      pose,
    };
  },
  eyesOn: 'a',
  solid(f, m, t) {
    f.strokes.unshift(core(scaleAt(sq(50, 45, 19, 12), 50, 45, moodK(m, t))));
    f.eyes = { x: 50, y: 45 };
    return f;
  },
};
